import styled from 'styled-components'
import { Accordion as Acordion } from '@material-ui/core'
import { Button as But } from 'components'
import { palette, spacing, typography, borders, flexbox, shadows, sizing } from '@material-ui/system'

import fonts from '../../styles/fonts.json'
import color from '../../styles/color.json'

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ecf9fd;
  background-image: url('/img/commonQuestion.png');

  height: 494px;
  width: 100%;
  padding: 0px 30px;

  .logoDiv {
    margin-bottom: 33px;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
  }

  h1 {
    ${fonts.h1};
    color: #ffffff;

    @media (max-width: 600px) {
      ${fonts.h1_mobile};
    }
  }
`

export const Accordion = styled(Acordion)`
  &&.MuiAccordion-root {
    ${palette};
    ${spacing};
    ${typography};
    ${borders};
    ${flexbox};
    ${shadows};
    ${sizing};

    width: 100%;
    padding: 5px 16px 5px 16px;

    border: 1px solid rgba(0, 0, 0, 0.07);
    box-sizing: border-box;
    box-shadow: 0px -1px 36px -4px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    text-align: start;

    ::before {
      height: 0px;
    }

    h4 {
      width: 100%;
      display: flex;
      align-items: center;

      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
    }

    h5 {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 47px;

      white-space: break-spaces;

      color: #757575;
    }

    &&.Mui-expanded {
      padding: 0px 0px 0px 16px;
      margin: 0px;
    }
  }

  @media (max-width: 600px) {
    &&.MuiAccordion-root {
      padding-left: 16px;
      text-align: start;
    }
  }
`

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  width: 100%;
  max-width: 1046px;
  margin-top: 52px;
  margin-bottom: 68px;
  padding: 0px 30px;
`
export const H4 = styled.h4`
  ${fonts.h4};
  color: ${color.gray[600]};
`

export const ButtonWhatsSup = styled(But)`
  width: 100%;
  height: 52px;
  max-width: 274px;

  span {
    ${fonts.p1}
    display: flex;
    justify-content: center;
    gap: 13.1px;
  }

  &.MuiButton-containedSecondary {
    color: #ffffff;
    background-color: ${color.green};
  }

  :hover {
    img {
      filter: invert(51%) sepia(88%) saturate(1596%) hue-rotate(96deg) brightness(90%) contrast(102%);
    }

    &.MuiButton-containedSecondary {
      color: ${color.green};
      background-color: transparent;
      border: 1px solid ${color.green};
    }
  }
`

export const ButtonEmailSup = styled(But)`
  width: 100%;
  height: 52px;
  max-width: 274px;

  span {
    ${fonts.p1}
    display: flex;
    justify-content: center;
    gap: 13.1px;
  }
`
export const ButtonDivInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  justify-content: center;
  margin: 15px 20px;
  gap: 10px;
`
